export type LabelColor = {
  id: string;
  name: string;
  hex: string;
  position: number;
};

export const GOLD_LABEL_COLOR = "#F5D76E";
